"use client";

import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpUPLT } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpUPLT";
import {
  OpeningYearForm,
  OpeningYearData,
  useSchema,
} from "@faire/retailer-visitor-shared/views/SignUp/opening-year/__internal__/OpeningYearStepForm";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Spacer } from "@faire/web/slate/spacing";
import { Formik } from "formik";
import React from "react";

export const OpeningYearStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const [{ reported_creation_time }] = useSignUpRequest([
    "reported_creation_time",
  ]);
  const schema = useSchema();
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.OPENING_YEAR
  );
  useSignUpUPLT({ step: Step.OPENING_YEAR });

  const onNext = (values: OpeningYearData) => {
    saveAndGoToNextStep({
      reported_creation_time: values.reported_creation_time,
    });
  };

  return (
    <SignupFormContainer>
      <SignUpTitle
        title={strictLocalize({
          defaultMessage: "When did your store open?",
          description: {
            img: "https://cdn.faire.com/fastly/94ecb99f917a2bb24542d2152ba93ef57e51ddd4517f23f3f21bd31d1a924ab7.png",
            text: "Title with user firstname asking when their store opened",
          },
        })}
      />
      <Spacer height="4x" />
      <Formik
        initialValues={{ reported_creation_time }}
        validationSchema={schema}
        onSubmit={onNext}
      >
        <OpeningYearForm />
      </Formik>
    </SignupFormContainer>
  );
};
